'use client'

import { useSorting, UseSortingProps } from '../hooks/UseSorting'
import { UseSortingModel } from '../types/Sorting'
import React, { useMemo, createContext } from 'react'

export interface SortingProviderProps extends UseSortingProps, React.HTMLAttributes<HTMLDivElement> {}
export interface SortingProviderModel extends UseSortingModel {}

export const SortingContext = createContext<SortingProviderModel>({} as SortingProviderModel)

export const SortingProvider = ({ initialSorting, children }: SortingProviderProps) => {
    const { sorting, sortHandler } = useSorting({ initialSorting })

    const SortingProviderData: SortingProviderModel = useMemo(
        () => ({
            sorting,
            sortHandler,
        }),
        [sorting],
    )

    return <SortingContext.Provider value={SortingProviderData}>{children}</SortingContext.Provider>
}
